"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const atoms_1 = require("@components/atoms");
const _utils_1 = require("@utils");
const ArticleTeaserOverlap_1 = require("./ArticleTeaserOverlap"); // Component
var ArticleTeaserFloat = function ArticleTeaserFloat(_ref) {
    var eyebrowLabel = _ref.eyebrowLabel, title = _ref.title, description = _ref.description, url = _ref.url, floatingImageUrl = _ref.floatingImageUrl, _ref$orientation = _ref.orientation, orientation = _ref$orientation === void 0 ? 'left' : _ref$orientation;
    return /*#__PURE__*/ react_1.default.createElement(StyledWrapper, {
        orientation: orientation
    }, /*#__PURE__*/ react_1.default.createElement(StyledImageSet, {
        orientation: orientation
    }, /*#__PURE__*/ react_1.default.createElement(StyledImageWrapper, null, /*#__PURE__*/ react_1.default.createElement(ArticleTeaserOverlap_1.TeaserImage, {
        src: floatingImageUrl,
        objectFit: "contain",
        widthClass: "float",
        alt: title
    }))), /*#__PURE__*/ react_1.default.createElement(StyledCopy, null, eyebrowLabel && /*#__PURE__*/ react_1.default.createElement(atoms_1.EyebrowLabel, {
        alignment: "left"
    }, eyebrowLabel), /*#__PURE__*/ react_1.default.createElement(ArticleTeaserOverlap_1.Header, {
        dangerouslySetInnerHTML: {
            __html: title
        }
    }), /*#__PURE__*/ react_1.default.createElement(ArticleTeaserOverlap_1.Subhead, {
        dangerouslySetInnerHTML: {
            __html: description
        }
    }), /*#__PURE__*/ react_1.default.createElement(ArticleTeaserOverlap_1.ButtonWrapper, null, /*#__PURE__*/ react_1.default.createElement(ArticleTeaserOverlap_1.StyledButton, {
        to: url,
        type: "black",
        shadow: true,
        size: "large"
    }, "Read more", /*#__PURE__*/ react_1.default.createElement("span", {
        className: "seoCopy"
    }, " about ", title)))), /*#__PURE__*/ react_1.default.createElement(atoms_1.LinkMask, {
        to: url
    }, title));
};
var StyledWrapper = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(ArticleTeaserOverlap_1.Wrapper, props);
}).withConfig({
    displayName: "ArticleTeaserFloat__StyledWrapper",
    componentId: "sc-1belct3-0"
})(["", "{justify-content:space-between !important;min-height:0px;}", "{min-height:0px;}", "{min-height:0px;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var StyledImageSet = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(ArticleTeaserOverlap_1.ImageSet, props);
}).withConfig({
    displayName: "ArticleTeaserFloat__StyledImageSet",
    componentId: "sc-1belct3-1"
})(["", "{width:calc(45% - 32px) !important;min-height:0 !important;}"], _utils_1.mediaQuery('tablet'));
var StyledImageWrapper = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(ArticleTeaserOverlap_1.ImageWrapper, props);
}).withConfig({
    displayName: "ArticleTeaserFloat__StyledImageWrapper",
    componentId: "sc-1belct3-2"
})(["overflow:visible !important;"]);
var StyledCopy = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(ArticleTeaserOverlap_1.Copy, props);
}).withConfig({
    displayName: "ArticleTeaserFloat__StyledCopy",
    componentId: "sc-1belct3-3"
})(["", "{width:calc(55% - 32px) !important;background:transparent !important;margin:0 !important;text-align:left !important;}"], _utils_1.mediaQuery('tablet'));
exports.default = ArticleTeaserFloat;
